import { Resources } from 'constants/resources';

import { useMemo } from 'react';

import { useGetOne } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { Gateway } from 'types/embedded/gateway';

import { GatewayRulesFormValues } from '../../hooks/useGatewayRulesForm';

type Params = {
  mappingIndex: number;
  mappingItemIndex: number;
  gateways: Gateway[];
  isLoadingGateways: boolean;
};

export function useGatewayChoices({
  mappingIndex,
  mappingItemIndex,
  gateways,
  isLoadingGateways,
}: Params) {
  const { watch } = useFormContext<GatewayRulesFormValues>();

  const gatewayWatched = watch(`mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.gateway`);

  const isGatewayInList = !gatewayWatched || gateways.some((g) => g.id === gatewayWatched);

  // выбранный шлюз может не попасть в список (например, статус вне active/test/pilot)
  const { data: selectedGateway } = useGetOne<Gateway>(
    Resources.Gateways,
    { id: gatewayWatched },
    {
      enabled: !isGatewayInList && !isLoadingGateways,
    },
  );

  const gatewayChoices = useMemo(
    () => (selectedGateway && !isGatewayInList ? [selectedGateway, ...gateways] : gateways),
    [gateways, selectedGateway, isGatewayInList],
  );

  return { gatewayChoices };
}
